import(/* webpackMode: "eager", webpackExports: ["RenderBuilderContent"] */ "/vercel/path0/components/builder.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-canary.113_react-dom@19.0.0-rc-3208e73e-20240730_react@19.0.0-rc-3208e73e-2024073_4xh4g4q6puzpsjuq53kgwaqj2y/node_modules/next/dist/client/image-component.js");
